import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';

// * https://stackoverflow.com/a/52949299
// * https://stackblitz.com/edit/angular-labs-copy-clipboard
@Directive({
    selector: '[aaCopyClipboard]',
    standalone: false
})
export class CopyClipboardDirective
{
    @Input('aaCopyClipboard') public payload: string;
    // @Input() public context: string;
    @Output() public copied: EventEmitter<string> = new EventEmitter<string>();

    @HostListener('click', ['$event'])
    public onClick (event: MouseEvent): void
    {
        copyTextToClipboard(event, this.payload, () =>
        {
            this.copied.emit(this.payload);
        });
    }
}

export const copyTextToClipboard = (
    event: MouseEvent,
    payload: string,
    callback?: () => void,
    _window?: any,
    _document?: Document,
) =>
{
    _window = _window || window;
    _document = _document || document;
    event.preventDefault();
    if (!payload)
    {
        return;
    }

    const listener = (e: ClipboardEvent) =>
    {
        // tslint:disable-next-line: no-string-literal
        const clipboard = e.clipboardData || _window['clipboardData'];
        clipboard.setData('text', payload.toString());
        e.preventDefault();
        if (callback !== undefined) callback();
    };

    _document.addEventListener('copy', listener, false);
    _document.execCommand('copy');
    _document.removeEventListener('copy', listener, false);
};